'use client';

import { ComponentProps } from 'react';
import { usePathname } from 'next/navigation';
import { HeaderAccountFeatures } from 'components/pcc-components';
import { useCSRFeatures } from '../../../hooks/use-csr-features';

type AccountFeaturesClientProps = { isCatCsrUser: boolean } & ComponentProps<
  typeof HeaderAccountFeatures
>;

export const AccountFeaturesClient = ({
  features,
  isCatCsrUser
}: AccountFeaturesClientProps) => {
  const csrFeatures = useCSRFeatures(isCatCsrUser);
  const pathname = usePathname();
  const featuresWithActiveNav = features.map((feature) => {
    return { isActive: feature.link === pathname, ...feature };
  });

  return (
    <HeaderAccountFeatures
      features={isCatCsrUser ? csrFeatures : featuresWithActiveNav}
    />
  );
};
